import {
  GET_BADGE_FIELDS_FAIL,
  GET_BADGE_FIELDS_REQUEST,
  GET_BADGE_FIELDS_RESET,
  GET_BADGE_FIELDS_SUCCESS,
  GET_BADGE_QUIZ_FAIL,
  GET_BADGE_QUIZ_REQUEST,
  GET_BADGE_QUIZ_RESET,
  GET_BADGE_QUIZ_SUCCESS,
  GET_DASHBOARD_BADGE_QUIZ_FAIL,
  GET_DASHBOARD_BADGE_QUIZ_REQUEST,
  GET_DASHBOARD_BADGE_QUIZ_SUCCESS,
  GET_QUIZ_RESULT_BY_ID_FAIL,
  GET_QUIZ_RESULT_BY_ID_REQUEST,
  GET_QUIZ_RESULT_BY_ID_RESET,
  GET_QUIZ_RESULT_BY_ID_SUCCESS,
  SELECTED_TECH_FIELD,
  SUBMIT_BADGE_QUIZ_FAIL,
  SUBMIT_BADGE_QUIZ_REQUEST,
  SUBMIT_BADGE_QUIZ_RESET,
  SUBMIT_BADGE_QUIZ_SUCCESS,
} from "../../constants/Badge/badgeConstants";

// Get Badge Fields Reducer
export const getBadgeFieldsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_BADGE_FIELDS_REQUEST:
      return { loading: true };
    case GET_BADGE_FIELDS_SUCCESS:
      return {
        loading: false,
        success: true,
        technologyFields: action.payload,
      };
    case GET_BADGE_FIELDS_FAIL:
      return { loading: false, error: action.payload };
    case GET_BADGE_FIELDS_RESET:
      return {};
    default:
      return state;
  }
};

// Get Badge Quiz Reducer
export const getBadgeQuizReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_BADGE_QUIZ_REQUEST:
      return { loading: true };
    case GET_BADGE_QUIZ_SUCCESS:
      return { loading: false, success: true, quizDetails: action.payload };
    case GET_BADGE_QUIZ_FAIL:
      return { loading: false, error: action.payload };
    case GET_BADGE_QUIZ_RESET:
      return {};
    default:
      return state;
  }
};

// Submit Badge Quiz Reducer
export const submitBadgeQuizReducer = (state = {}, action) => {
  switch (action.type) {
    case SUBMIT_BADGE_QUIZ_REQUEST:
      return { loading: true };
    case SUBMIT_BADGE_QUIZ_SUCCESS:
      return { loading: false, success: true, result: action.payload };
    case SUBMIT_BADGE_QUIZ_FAIL:
      return { loading: false, error: action.payload };
    case SUBMIT_BADGE_QUIZ_RESET:
      return {};
    default:
      return state;
  }
};

export const selectedTechFieldReducer = (state = {}, action) => {
  switch (action.type) {
    case SELECTED_TECH_FIELD:
      return {
        userSelectedTechField: action.payload,
      };

    default:
      return state;
  }
};

export const getQuizResultByIdReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_QUIZ_RESULT_BY_ID_REQUEST:
      return { loading: true };
    case GET_QUIZ_RESULT_BY_ID_SUCCESS:
      return { loading: false, success: true, result: action.payload };
    case GET_QUIZ_RESULT_BY_ID_FAIL:
      return { loading: false, error: action.payload };
    case GET_QUIZ_RESULT_BY_ID_RESET:
      return {};
    default:
      return state;
  }
};
export const getDashboardCompletedQuizReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_DASHBOARD_BADGE_QUIZ_REQUEST:
      return { loading: true };
    case GET_DASHBOARD_BADGE_QUIZ_SUCCESS:
      return { loading: false, success: true, result: action.payload };
    case GET_DASHBOARD_BADGE_QUIZ_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
